












































































































































































// 企业端pc模板
import JSEncrypt from "jsencrypt";
export default {
  name: "enterprise-enterpriseTemplate-pc",
  data() {
    return {
      openEye: false,
      clock: false,
      checked: false,
      time: 60,
      avoid: false,
      aggreementList: [
        {
          title: "用户注册协议",
          url: "",
        },
        {
          title: "用户隐私协议",
          url: "",
        },
      ],
      tabList: [
        {
          title: "验证码登录",
          type: "code",
          loginAccount: "",
          loginCheckInfo: "",
          testPhone: false,
          testCode: false,
        },
        {
          title: "密码登录",
          type: "password",
          loginAccount: "",
          loginCheckInfo: "",
          testPhone: false,
          testPassword: false,
        },
      ],
      idx: 0,
      qrCode: false,
    };
  },
  props: ["config"],
  computed: {
    next() {
      const instance = this as any;
      return (
        instance.checked &&
        instance.tabList[instance.idx].loginAccount &&
        instance.tabList[instance.idx].loginCheckInfo &&
        !instance.tabList[instance.idx].testPhone &&
        !instance.tabList[instance.idx].testPassword &&
        !instance.tabList[instance.idx].testCode
      );
    },
  },
  watch: {
    avoid: {
      handler(newCul: boolean) {
        const params: any = {
          avoid: newCul,
          time: (this as any).config.loginEffectiveTime || 0,
        };
        (this as any).$emit("avoid-login", params);
      },
      immediate: true,
    },
    config: {
      handler(newCul: any) {
        const instance = this as any;
        instance.checked = newCul.protocolStatus;
      },
      immediate: true,
    },
  },
  mounted() {
    console.log((this as any).$attrs, "loginCheckInfo");
  },
  methods: {
    limit(key: string) {
      const instance = this as any;
      if (
        key === "loginAccount" &&
        instance.tabList[instance.idx][key].length > 11
      ) {
        instance.tabList[instance.idx][key] = instance.tabList[instance.idx][
          key
        ].slice(0, 11);
      }
    },
    test(key: string) {
      const instance = this as any;
      if (key === "loginAccount") {
        const phoneReg = /^[1][0-9]{10}$/;
        if (
          !instance.tabList[instance.idx][key] ||
          !phoneReg.test(instance.tabList[instance.idx][key])
        ) {
          instance.tabList[instance.idx]["testPhone"] = true;
        } else {
          instance.tabList[instance.idx]["testPhone"] = false;
        }
      }
    },
    clickFun(index: number) {
      const instance = this as any;
      instance.idx = index;
    },
    sendSms() {
      const instance = this as any;
      const phoneReg = /^[1][0-9]{10}$/;
      if (
        !instance.tabList[instance.idx].loginAccount ||
        !phoneReg.test(instance.tabList[instance.idx].loginAccount)
      ) {
        instance.tabList[instance.idx].testPhone = true;
        return;
      }
      instance.clock = true;
      instance.time = 60;
      const inter = setInterval(() => {
        instance.time--;
        if (instance.time <= 0) {
          clearInterval(inter);
          instance.clock = false;
        }
      }, 1000);
      const config = instance.config;
      const params = {
        businessType: 1,
        phone: instance.tabList[instance.idx].loginAccount,
        smsType: config.smsType,
        userType: config.userType,
      };
      instance.$emit("send-sms", params);
    },
    encryptDeal(msg: string) {
      const publicKey =
        "MFwwDQYJKoZIhvcNAQEBBQADSwAwSAJBAKbpotLkdWJlxvWuydKwQkryMb3m2mZrj8tizRUbwBW9Bnyu0syIXz+IkxP6Z76b4cEO2NyEq5yPcJdaBKynSVcCAwEAAQ==";

      const encrypt = new JSEncrypt();
      encrypt.setPublicKey(publicKey);
      return encrypt.encrypt(msg);
    },
    login() {
      const instance = this as any;
      if (!instance.next) return;
      const config = instance.config;
      const params = {
        account: instance.tabList[instance.idx].loginAccount,
        checkInfo: instance.idx
          ? instance.encryptDeal(instance.tabList[instance.idx].loginCheckInfo)
          : instance.tabList[instance.idx].loginCheckInfo,
        configId: config.id,
        source: "pc",
        userType: config.userType,
        type: instance.idx ? "01" : "02",
      };
      instance.$emit("login-handle", params);
    },
    goForget() {
      (this as any).$emit("go-forget");
    },
    goRegister() {
      (this as any).$emit("go-register");
    },
    goUrl(url: string) {
      window.location.href = url;
    },
  },
};
